import { render, staticRenderFns } from "./attachments.vue?vue&type=template&id=471c794b&"
import script from "./attachments.vue?vue&type=script&lang=js&"
export * from "./attachments.vue?vue&type=script&lang=js&"
import style0 from "./attachments.vue?vue&type=style&index=0&id=471c794b&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/kivateknoloji/kivacloud/corona-ux/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('471c794b')) {
      api.createRecord('471c794b', component.options)
    } else {
      api.reload('471c794b', component.options)
    }
    module.hot.accept("./attachments.vue?vue&type=template&id=471c794b&", function () {
      api.rerender('471c794b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tasks/main/attachments.vue"
export default component.exports